const { getConfig } = require("@cirrus/config")
const { Automatic, Enforced } = require("@cirrus/legacy/app-common/enums/ssoMode.js")

export const getSamlUrl = () => {
  const config = getConfig()

  return config.SSOApiHost + "/" + config.Customer + "/saml2/login"
}

export const checkStartPageAllowed = ({ ssoMode }) => ssoMode !== Automatic && ssoMode !== Enforced
export const checkLoginPageAllowed = ({ ssoMode }) => ssoMode !== Enforced
